/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_CashierInputs */

const vi_receipt_label_cashier = /** @type {(inputs: Receipt_Label_CashierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu Ngân`)
};

/**

* @param {Receipt_Label_CashierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_cashier = /** @type {((inputs?: Receipt_Label_CashierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_CashierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_cashier(inputs)
});